module.exports = __webpack_public_path__ + "static/media/005.5f2520d9.jpg";